import { AppSessionService } from '../shared/common/session/app-session.service';
import { AppUiCustomizationService } from '../shared/common/ui/app-ui-customization.service';
import { PrimengTableHelper } from '../shared/helpers/primeng-table-helper';
import { AbpMultiTenancyService } from 'abp-ng2-module/src/multi-tenancy/abp-multi-tenancy.service';
import { LocalizationService } from 'abp-ng2-module/src/localization/localization.service';
import { PermissionCheckerService } from 'abp-ng2-module/src/auth/permission-checker.service';
import { FeatureCheckerService } from 'abp-ng2-module/src/features/feature-checker.service';
import { NotifyService } from 'abp-ng2-module/src/notify/notify.service';
import { SettingService } from 'abp-ng2-module/src/settings/setting.service';
import { MessageService } from 'abp-ng2-module/src/message/message.service';
import { AppConsts } from './AppConsts';
var AppComponentBase = /** @class */ (function () {
    function AppComponentBase(injector) {
        this.localizationSourceName = AppConsts.localization.defaultLocalizationSourceName;
        this.localization = injector.get(LocalizationService);
        this.permission = injector.get(PermissionCheckerService);
        this.feature = injector.get(FeatureCheckerService);
        this.notify = injector.get(NotifyService);
        this.setting = injector.get(SettingService);
        this.message = injector.get(MessageService);
        this.multiTenancy = injector.get(AbpMultiTenancyService);
        this.appSession = injector.get(AppSessionService);
        this.ui = injector.get(AppUiCustomizationService);
        this.primengTableHelper = new PrimengTableHelper();
    }
    AppComponentBase.prototype.l = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        args.unshift(key);
        args.unshift(this.localizationSourceName);
        return this.ls.apply(this, args);
    };
    AppComponentBase.prototype.ls = function (sourcename, key) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var localizedText = this.localization.localize(key, sourcename);
        if (!localizedText) {
            localizedText = key;
        }
        if (!args || !args.length) {
            return localizedText;
        }
        if (args.length === 1 && Array.isArray(args[0])) {
            args[0].unshift(localizedText);
            return abp.utils.formatString.apply(this, args[0]);
        }
        else {
            args.unshift(localizedText);
            return abp.utils.formatString.apply(this, args);
        }
    };
    AppComponentBase.prototype.isGranted = function (permissionName) {
        return this.permission.isGranted(permissionName);
    };
    AppComponentBase.prototype.isGrantedAny = function () {
        var permissions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            permissions[_i] = arguments[_i];
        }
        if (!permissions) {
            return false;
        }
        for (var _a = 0, permissions_1 = permissions; _a < permissions_1.length; _a++) {
            var permission = permissions_1[_a];
            if (this.isGranted(permission)) {
                return true;
            }
        }
        return false;
    };
    AppComponentBase.prototype.s = function (key) {
        return abp.setting.get(key);
    };
    AppComponentBase.prototype.appRootUrl = function () {
        // 获取在fcloud处理好的 appRootUrl
        var appRootUrl = localStorage.getItem('appRootUrl');
        return appRootUrl;
    };
    AppComponentBase.prototype.setFrozenColumnHeight = function () {
        var unfrozenTrs = document.getElementsByClassName('p-table-get-unfrozen-column-height');
        var frozenTrs = document.getElementsByClassName('p-table-change-frozen-column-height');
        for (var index = 0; index < unfrozenTrs.length; index++) {
            var unfrozenTr = unfrozenTrs[index];
            var height = unfrozenTr.offsetHeight;
            var frozenTr = frozenTrs[index];
            if (frozenTr) {
                frozenTr.setAttribute('height', String(height));
            }
        }
    };
    return AppComponentBase;
}());
export { AppComponentBase };
